import type { FunctionSearchSource } from './types';

const OPEN_EVENT = 'agora:function-search:open';

export const openFunctionSearch = (source: FunctionSearchSource): void => {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { source } }));
};

export const onFunctionSearchOpen = (listener: (source: FunctionSearchSource) => void): (() => void) => {
  const handler = (event: Event) => {
    const source = (event as CustomEvent<{ source?: FunctionSearchSource }>).detail?.source;
    listener(source === 'rail' || source === 'topbar' ? source : 'keyboard');
  };
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
};
